export const info = Symbol(`INFO`)
export const error = Symbol(`ERROR`)
